const initSnowplow = (collectorUrl) => {
  if (!collectorUrl) {
    console.error("Snowplow collector URL is not provided.");
    return;
  }

  (function (p, l, o, w, i, n, g) {
    if (!p[i]) {
      p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
      p.GlobalSnowplowNamespace.push(i);
      p[i] = function () {
        (p[i].q = p[i].q || []).push(arguments);
      };
      p[i].q = p[i].q || [];
      n = l.createElement(o);
      g = l.getElementsByTagName(o)[0];
      n.async = 1;
      n.src = w;
      g.parentNode.insertBefore(n, g);
    }
  })(
    window,
    document,
    'script',
    'https://views.medibuddy.in/snowplow/sp.js',
    'snowplow'
  );

  window.snowplow(
    'newTracker',
    'snow-plow-tracker',
    collectorUrl,
    {
      appId: 'web-events-manager',
      platform: 'web',
      discoverRootDomain: true,
      cookieSameSite: 'Lax',
    }
  );
  window.snowplow('trackPageView');
};

export default initSnowplow;
